<template>
  <a-drawer
    title="绑定医生"
    placement="right"
    v-model:visible="docVisible"
    @close="onClose"
    width="644px"
    :z-index="9999"
    class="bind_doc_drawer"
  >
    <a-spin class="spinning" :spinning="loading">
      <div class="container">
        <div class="list">
          <div
            class="doctap"
            v-for="(item, index) in bindDocList"
            :key="item.ucDoctorId"
            :class="{ right: index % 2 !== 0 }"
          >
            <div class="course_sign" v-if="[0, 1, 2].includes(item.courseServicesFlag)">
              <a-tooltip
                placement="top"
                :getPopupContainer="getPopupContainer"
                overlayClassName="course_tips"
              >
                <template #title>
                  <span>{{ showPopExcus(item) }}</span>
                </template>
                <div class="flag_str" :class="[item.courseServicesFlag ? 'flag_join' : 'flag_ex']">
                  <span v-if="item.courseServicesFlag === 1">已加入</span>
                  <span v-else-if="item.courseServicesFlag === 0">待加入</span>
                  <span v-else-if="item.courseServicesFlag === 2">未加入</span>
                  <InfoCircleOutlined style="font-size: 10px" />
                </div>
              </a-tooltip>
            </div>
            <div class="content">
              <div class="info">
                <span class="name">{{ item.doctorName }}</span>
                <span class="txt depart">{{ item.departmentName }}</span>
                <span class="txt">{{ item.academicTitle }}</span>
              </div>
              <div class="hosp">{{ item.hospitalName }}</div>
            </div>
            <div class="explain z-flex">
              <span class="source">来源：{{ item.bindSourceDesc }}</span>
              <span class="date">{{ item.bindTime }}</span>
            </div>
          </div>
        </div>
        <div class="pagination">
          <a-pagination
            show-size-changer
            v-model:current="pagination.current"
            v-model:pageSize="pagination.pageSize"
            :total="pagination.total"
            @change="onShowSizeChange"
            @showSizeChange="onShowSizeChange"
            :show-total="total => `总共 ${pagination.total} 条`"
          />
        </div>
      </div>
    </a-spin>
  </a-drawer>
</template>
<script setup>
import { defineProps, ref, watch, defineEmits, reactive, computed } from 'vue'
import { getBindDocList } from '@/api/chat'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
const props = defineProps({
  bindDocVisible: {
    type: Boolean,
    default: false,
    required: true
  }
})
const emits = defineEmits(['onClose'])
const store = useStore()
const curOrder = computed(() => store.state.workOrder.workOrderGroupInfo)
const docVisible = ref(false)
const loading = ref(false)
const bindDocList = ref([])
const initPagination = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
const pagination = reactive({ ...initPagination })
const params = reactive({
  current: 1,
  size: 10,
  ucPatientId: curOrder.value.patientInfo.ucUserId
})
watch(
  () => props.bindDocVisible,
  val => {
    docVisible.value = val
    if (val) {
      Object.assign(pagination, initPagination)
      getData()
    }
  }
)
function onClose() {
  emits('onClose')
}
// // 查询数据
function getData() {
  loading.value = true
  const { current, pageSize } = pagination
  params.current = current
  params.size = pageSize
  try {
    getBindDocList({ ...params }).then(res => {
      const { list = [], currPage, totalCount } = res
      bindDocList.value = list
      loading.value = false
      pagination.current = currPage
      pagination.total = totalCount
    })
  } catch {
    loading.value = false
    bindDocList.value = []
  }
}
// 改变每页条数
const onShowSizeChange = (page, pageSize) => {
  pagination.current = page
  pagination.pageSize = pageSize
  getData()
}

const getPopupContainer = trigger => {
  return trigger.parentNode
}

const showPopExcus = item => {
  const { courseServicesFlag, courseServicesCause } = item
  const excusList = [
    '患者待加入全病程服务',
    '患者已加入全病程服务',
    `患者未加入全病程服务:${courseServicesCause}`
  ]
  return excusList[courseServicesFlag]
}
</script>
<style lang="scss">
.course_tips {
  min-width: 190px;
  text-align: center;
  display: flex;
  align-items: center;
}
</style>
<style scoped lang="scss">
%time {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}

.container {
  height: calc(100vh - 103px);
  overflow: scroll;
  padding: 0 8px;
  .search-wrap {
    margin-bottom: 20px;
  }
  .list {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    .doctap {
      display: flex;
      flex-direction: column;
      background: #f8f8f8;
      border-radius: 8px;
      padding: 12px;
      margin-right: 12px;
      margin-bottom: 12px;
      position: relative;
      .course_sign {
        position: absolute;
        top: 0;
        right: 0;
        .flag_str {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          width: 60px;
          height: 20px;
          border-radius: 0 8px 0 8px;
        }
        .flag_join {
          background: #1890ff1a;
          color: #1890ff;
        }
        .flag_ex {
          background: #f0f0f0;
          color: #666666;
        }
      }
      &.right {
        margin-right: 0;
      }
      .content {
        flex: 1;
        .info {
          margin-bottom: 9px;
          .name {
            font-size: 14px;
            color: #1a1a1a;
            padding-right: 12px;
          }
          .txt {
            font-size: 12px;
            color: #999999;
          }
          .depart {
            padding-right: 6px;
            margin-right: 6px;
            border-right: 1px solid #999999;
          }
        }
        .hosp {
          margin-bottom: 19px;
          font-weight: 400;
          font-size: 12px;
          color: #3b3b3b;
        }
      }

      .explain {
        .source {
          font-weight: 400;
          font-size: 12px;
          color: #3b3b3b;
        }
        .date {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
  .pagination {
    padding: 12px 0 20px;
  }
}
</style>
